
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { IoIosClose } from "react-icons/io";

import { Container, Close, BoxImage, BoxInfor, ItemMenu, BoxMenu } from "./styled";
import { useState } from 'react';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { translations } from '../../../../utils/language';
import { ArrowDownOnSquareIcon, ArrowPathIcon, ArrowPathRoundedSquareIcon, ArrowTopRightOnSquareIcon, CodeBracketIcon, EnvelopeIcon, LockClosedIcon, LockOpenIcon, TrashIcon } from '@heroicons/react/24/outline';
import ModalUpdateLicenses from '../modal-update-licenses';
import { useHistory } from 'react-router-dom';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: "white",
        padding: "0px",
        margin: "0px",
        borderRadius: "10px"
    },
    overlay: {
        backgroundColor: "rgba(10,23,55,0.5)",
        zIndex: "99999999"
    }
};



const ModalMenuItem = (props) => {

    const dispatch = useDispatch()
    const history = useHistory()


    const deleteItem = () => {
        //console.log("saveEmail", props.id, email)
        dispatch({ type: "SAGA_DELETE_LICENSES", payload: props.item.id, });
    }



    return (
        <Modal
            isOpen={props.visible}
            style={customStyles}
            ariaHideApp={false}
            onRequestClose={() => { props.setVisibleModal(false) }}
        >

            <Container>
                <Close onClick={() => { props.setVisibleModal(false) }}><IoIosClose size={25} color={"gray"} /></Close>
                <BoxMenu>

                    {/* <Item
                        image={
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-8">
                                <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                            </svg>
                        }
                        action={() => { props.setVisibleModalEdit(true); props.setVisibleModal(false) }}
                        item={props.item}
                        title={"Editar e-mail"}
                        desc={"Atualizar e-mail do pedido"} /> */}

                    <Item
                        image={
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-8">
                                <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                            </svg>
                        }
                        action={() => { props.setVisibleModalUpdate(true); props.setVisibleModal(false) }}
                        item={props.item}
                        title={"Renomear"}
                        desc={"Enviar ou reenviar o e-mail do pedido"} />


                    <Item
                        image={<TrashIcon style={{ width: "32px" }} />}
                        action={() => { deleteItem() }}
                        item={props.item}
                        title={"Excluír"}
                        desc={"Enviar ou reenviar o e-mail do pedido"} />

                    <Item
                        image={<CodeBracketIcon style={{ width: "32px" }} />}
                        action={() => { history.push(`/licencas/${props.item.id}/codigos`) }}
                        item={props.item}
                        title={"Adicionar códigos"}
                        desc={"Adicione códigos a essa licença"} />

                    {/* <Item
                        image={
                            props.item.is_canceled == 0 ?
                                <LockClosedIcon style={{ width: "32px" }} /> :
                                <LockOpenIcon style={{ width: "32px" }} />
                        }
                        action={updateStatus}
                        item={props.item}
                        title={props.item.is_canceled == 0 ? "Bloquear" : "Desbloquear"}
                        desc={"Bloquear ou desbloquer a página de downloads desse pedido"} />

                    <Item
                        image={<ArrowTopRightOnSquareIcon style={{ width: "32px" }} />}
                        action={() => { window.open(props.item.order_link, "_blank") }}
                        item={props.item}
                        title={"Acessar"}
                        desc={"Acessar página de downloads desse pedido."} /> */}

                </BoxMenu>
            </Container>
        </Modal>
    )
}

export default ModalMenuItem


const Item = (props) => {

    const dispatch = useDispatch()

    useEffect(() => {
        //console.log("props_", props)
    }, [props])


    const [hover, setHover] = useState(false)


    return (
        <ItemMenu onClick={() => { props.action() }} hover={hover} onMouseLeave={() => { setHover(false) }} onMouseEnter={() => { setHover(true) }}>
            <BoxImage hover={hover}>
                {props.image}
            </BoxImage>
            <BoxInfor>
                <label>{props.title}</label>
                <p>{props.desc}</p>
            </BoxInfor>
        </ItemMenu>
    )
}

